<template>
  <div
    v-if="show"
    class="toast"
  >
    <div>
      <div class="toast__content">
        <div class="header">
          <div class="wrapper">
            <img
              :src="urlIcon"
              alt="icon"
              class="icon"
            >
            <p class="toast__title">
              {{ title }}
            </p>
          </div>

          <button
            class="btn-close"
            @click="$emit('close')"
          >
            X
          </button>
        </div>
        <p class="toast__message">
          {{ message }}
        </p>
      </div>
    </div>
  </div>
</template>

<script scoped>
export default {
  name: 'Toast',
  props: {
    show: {
      type: Boolean,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    urlIcon: {
      type: String,
      required: true
    },
    duration: {
      type: Number,
      default: 3000
    }
  },
  watch: {
    show(newValue) {
      if (newValue) {
        setTimeout(() => {
          this.$emit('close');
        }, this.duration);
      }
    }
  }
}
</script>

<style>
  .toast {
    position: fixed;
    bottom: 78px;
    right: 51px;
    background-color: #fff;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    padding: 10px;
    z-index: 1000;
    height: 102px;
    padding-left: 32px;
    width: 484px;
  }

  .header {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }

  .wrapper {
    display: flex;
    align-items: center;
    margin-bottom: 6px;
  }

  .icon {
    width: 22px;
    margin-right: 8px;
  }

  .toast__title {
    font-weight: bold;
    font-size: 18px;
    color: #595959;
  }

  .toast__content {
    display: flex;
    flex-direction: column;
    align-items: start;
  }

  .toast__icon {
    margin-right: 10px;
  }

  .toast__message {
    margin: 6px 0;
  }

  .btn-close {
    background-color: transparent;
    border: none;
    cursor: pointer;
    font-size: 21px;
    color: #1616163D;
    position: absolute;
    right: 1rem;
    top: 0;
  }
</style>
